import React from 'react';
import { List, Typography } from 'antd';

import { FormattedMessage, useIntl } from '../../util/reactIntl';
import { newIdempotencyKey } from '../../util/idempotencyKey';
import { networkMessagesAction } from '../../util/api';

const { Text } = Typography;

/**
 * Sends one of a company's messages to its network. A preview, a send and an announcement each carry
 * a fresh key, so a double click is sent once.
 */
export const sendNetworkMessage = body =>
  networkMessagesAction(['preview', 'send', 'announce'].includes(body.action) ? { ...body, idempotencyKey: newIdempotencyKey() } : body);

const SKIP_REASONS = ['limit', 'preference', 'not_linked', 'failed'];

/** Who a send skipped, and why: a limit says when they can next be reached. */
export const SkipList = ({ skipped }) => {
  const intl = useIntl();
  if (!skipped || !skipped.length) return null;
  return (
    <List
      size="small"
      dataSource={skipped}
      renderItem={skip => {
        const reason = SKIP_REASONS.includes(skip.reason) ? skip.reason : 'failed';
        const when = skip.nextAt ? intl.formatDate(skip.nextAt, { month: 'short', day: 'numeric' }) : null;
        return (
          <List.Item key={skip.entryId}>
            <Text strong>{skip.name || intl.formatMessage({ id: 'TellNetworkModal.someone' })}</Text>
            <Text type="secondary">
              {skip.cap ? (
                <FormattedMessage id={`TellNetworkModal.blocked.${skip.cap}`} values={{ date: when }} />
              ) : (
                <FormattedMessage id={`TellNetworkModal.skip.${reason}`} />
              )}
            </Text>
          </List.Item>
        );
      }}
    />
  );
};
